module.exports = __webpack_public_path__ + "static/media/F35Pricetag.ab6fd513.jpg";